__webpack_require__.p = "/assets/turbo/9e4692cc/quellede/_next/";